import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
export const iconSizes = {
    xsmall: 16,
    small: 20,
    medium: 24
};
export const IconBase = /*#__PURE__*/ forwardRef(function IconBase({ children, fill = 'none', viewBox, 'data-testid': testId, size = 18, width, height, ...rest }, ref) {
    const baseSize = typeof size === 'number' ? size : iconSizes[size];
    const hasAccessibleText = Boolean(rest['aria-label'] || rest['aria-labelledby'] || rest.role && rest.role !== 'presentation' && rest.role !== 'none');
    const role = rest.role || (!hasAccessibleText ? 'presentation' : undefined);
    return /*#__PURE__*/ _jsx("svg", {
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: width ?? baseSize,
        height: height ?? baseSize,
        viewBox: viewBox,
        fill: fill,
        shapeRendering: "geometricPrecision",
        "data-testid": testId,
        css: {
            flexShrink: 0
        },
        role: role,
        ...rest,
        children: children
    });
});

//# sourceMappingURL=iconBase.js.map